import { Moment } from 'moment'
import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/PagedList'

export interface PagedAuditResult extends PagedList<AuditResult> {}

export interface AuditResult {
  expenseNumber: number
  companyId: string
  userId: string
  status: string
  amount: number
  recordType: string
  category: string
  reviewedOn?: string
  submittedOn?: string
  firstSubmittedOn?: string
  turnAroundTimeInHours: number
  cycleTimeInHours: number
  reviewerTouches: number
  reviewedBy: string
  productType: string
  missingParts: string
  planYear: number
  expenseId: string
  isDuplicate: boolean
}

export interface AuditResultFilter {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  company?: string
  docReviewer?: string
  employee?: string
  startDate?: string
  endDate?: string
}

export const getAuditResults = (filter: AuditResultFilter): Promise<PagedAuditResult> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'expenseNumber',
    orderDescending: false,
    company: '',
    docReviewer: '',
    employee: '',
    startDate: null,
    endDate: null,
  }

  return adminHttpClient.get('/csi/ExpenseAudit/Search', filter)
}

export const getAuditResultsCsv = (filter: AuditResultFilter): Promise<any> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: -1,
    orderColumn: 'expenseNumber',
    orderDescending: false,
    company: '',
    docReviewer: '',
    employee: '',
    startDate: null,
    endDate: null,
  }

  return adminHttpClient.get('/csi/ExpenseAudit/Search/CSV', filter)
}
